import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CookieHelper } from '../../../common/cookie-helper';
import { ICorporatePartner } from '../../../corporate-partner/corporate-partner.interface';
import { Tooltip } from '../../../model/content/contentTooltip.model';
import { ContentBook } from '../../../model/content/contentbook.model';
import { AccountSummaryService } from '../../../services/accountsummary/account-summary.service';
import { ContentHeaderFooterService } from '../../../services/content/contentheaderfooter.service';

@Component({
  selector: 'ngc-search-options',
  templateUrl: 'search-options.component.html',
  styleUrls: ['./search-options.component.scss']
})
export class SearchOptionsComponent implements OnChanges, OnDestroy, OnInit {
  @Input() content: ContentBook;
  @Input() bookWidgetForm: UntypedFormGroup;
  @Input() restrictmpmTravel;
  @Input() disabledByEdocData;
  @Input() awardTravel;
  @Input() isMilesMobileRedirect;
  @Input() mpmTravel;
  @Input() isFlexAirPort;
  @Input() restrictMiles;
  @Input() corpPartner: ICorporatePartner;
  @Input() flightPlusHotel;
  @Input() restrictFlightHotel;
  @Input() flightHotelContent;
  @Input() selectTripType;
  @Input() restrictCash;
  @Input() canBookNonRefundable: string;
  canBookNonRefundableValue = true;
  isBusiness = false;
  @Output() flightPlusHotelClicked = new EventEmitter<any>();
  @Output() awardTravelChanged = new EventEmitter<string>();
  @Output() flexiDatesChanged = new EventEmitter<boolean>();
  toolTipContent: Tooltip;
  accountSummaryServiceSubscribe: Subscription;
  private unsubscribe: Subject<void> = new Subject();
  showNewProfileSelector = false;
  profileSelectorEnableMilesFlag = false;

  constructor(
    private accountSummaryService: AccountSummaryService,
    private cookieHelper: CookieHelper,
    private cdn: ChangeDetectorRef,
    private contentService: ContentHeaderFooterService
  ) {}

  ngOnInit(): void {
    this.contentService.contentHeaderFooter
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((data) => {
        if (data) {
          this.showNewProfileSelector = !!data.header.enableNewProfileSelector;
          this.profileSelectorEnableMilesFlag =
            data.header.enableMilesNewProfileSelector;
          if (this.showNewProfileSelector) {
            const accountCookie = this.cookieHelper.getCookieValue('account');
            if (accountCookie && accountCookie.length) {
              const accountCookieJson = JSON.parse(accountCookie);
              if (accountCookieJson['isBusiness']) {
                this.isBusiness = true;
                this.getValueForRefundableFares();
              }
            }
          }
        }
      });

    if (!this.canBookNonRefundable) {
      this.canBookNonRefundableValue = true;
      this.getTooltipForNonRefundable();
    }
  }

  getValueForRefundableFares() {
    const accountCookie = this.cookieHelper.getCookieValue('account');
    if (this.canBookNonRefundable && accountCookie && accountCookie.length) {
      const accountCookieJson = JSON.parse(accountCookie);
      const canBookNonRefundableList = this.canBookNonRefundable.split('|');
      this.checkForRefundableList(
        accountCookie,
        canBookNonRefundableList,
        accountCookieJson
      );
    }
  }

  checkForRefundableList(
    accountCookie,
    canBookNonRefundableList,
    accountCookieJson
  ) {
    if (
      (canBookNonRefundableList[
        accountCookie.charAt(accountCookie.length - 3)
      ] === 'false' ||
        canBookNonRefundableList[
          accountCookieJson['businessAccountOptionsList'].accountIndex
        ] === 'false') &&
      accountCookieJson['isBusiness']
    ) {
      if (this.profileSelectorEnableMilesFlag) {
        this.restrictMiles =
          accountCookieJson['businessAccountOptionsList'].disableMiles ||
          this.corpPartner.disableMiles;
      } else {
        this.restrictMiles = true;
      }

      this.canBookNonRefundableValue = false;
      this.bookWidgetForm.controls['refundableFlightsOnly'].setValue(true);
      this.getTooltipForNonRefundable();
      this.cdn.detectChanges();
    } else {
      if (
        accountCookieJson['isBusiness'] &&
        this.profileSelectorEnableMilesFlag
      ) {
        this.restrictMiles =
          accountCookieJson['businessAccountOptionsList'].disableMiles ||
          this.corpPartner.disableMiles;
      } else if (
        accountCookieJson['isBusiness'] &&
        !this.profileSelectorEnableMilesFlag
      ) {
        this.restrictMiles = true;
      } else {
        this.restrictMiles = false;
      }

      this.canBookNonRefundableValue = true;
      this.bookWidgetForm.controls['refundableFlightsOnly'].setValue(false);
      this.getTooltipForNonRefundable();
      this.cdn.detectChanges();
    }
  }

  getTooltipForNonRefundable() {
    if (!this.canBookNonRefundableValue) {
      this.toolTipContent = this.content.tooltips.get(
        'corporate-travel-refundable-fare'
      );
    } else {
      this.toolTipContent = this.content.tooltips.get('refundable-fares');
    }
    return this.toolTipContent;
  }

  ngOnChanges(simpleChanges: SimpleChanges) {
    if (simpleChanges && simpleChanges['isFlexAirPort']) {
      if (this.isFlexAirPort) {
        this.bookWidgetForm.controls['chkFlexDate'].setValue(false);
        this.flexiDatesChanged.emit(false);
      }
    }
    if (
      simpleChanges &&
      (simpleChanges.canBookNonRefundable || simpleChanges.corpPartner)
    ) {
      this.getValueForRefundableFares();
    }
  }

  shopWithMilesClicked(event) {
    if (event.target.checked) {
      this.bookWidgetForm.controls['refundableFlightsOnly'].setValue(false);
      this.bookWidgetForm.controls['schedulePrice'].setValue('miles');
      if (
        !this.isFlexAirPort &&
        this.bookWidgetForm.controls['chkFlexDate'] &&
        this.selectTripType !== 'MULTICITY'
      ) {
        if (
          this.isBusiness &&
          (!this.corpPartner.disableMiles || !this.restrictMiles)
        ) {
          this.bookWidgetForm.controls['chkFlexDate'].setValue(false);
        } else {
          this.bookWidgetForm.controls['chkFlexDate'].setValue(true);
        }
      }
      this.awardTravelChanged.emit('miles');
    } else {
      if (this.isBusiness) {
        this.getValueForRefundableFares();
      }
      this.bookWidgetForm.controls['schedulePrice'].setValue('price');
      this.bookWidgetForm.controls['chkFlexDate'].setValue(false);
      this.awardTravelChanged.emit('price');
    }
  }

  setValuesForMilesClicked() {
    if (
      !this.isFlexAirPort &&
      this.bookWidgetForm.controls['chkFlexDate'] &&
      this.selectTripType !== 'MULTICITY'
    ) {
      this.bookWidgetForm.controls['chkFlexDate'].setValue(true);
    }
    this.awardTravelChanged.emit('miles');
  }

  shopWithMoneyPlustMilesClicked(event) {
    if (event.target.checked) {
      this.bookWidgetForm.controls['schedulePrice'].setValue('milesplusmoney');
      this.awardTravelChanged.emit('milesplusmoney');
    }
  }

  flexiDatesClicked(event) {
    this.flexiDatesChanged.emit(event.target.checked);
  }

  redirectMilesPlusMoney(event) {
    // #todo
  }

  onFlightPlusHotelClicked(event) {
    this.flightPlusHotelClicked.emit(event);
  }

  ngOnDestroy() {
    if (this.accountSummaryServiceSubscribe) {
      this.accountSummaryServiceSubscribe.unsubscribe();
    }
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.unsubscribe.unsubscribe();
  }
}
